// extracted by mini-css-extract-plugin
export var centralized = "c8_jl";
export var rightColumn = "c8_jj";
export var stickyColumn = "c8_jk";